import type { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { OK } from 'autogen/translation-keys/trans-website-shared';
import { Button } from 'components/Button';
import ensureCookieConsentReady from 'components/CookieConsent/ensureCookieConsentReady';
import Card from 'components/generic/card';
import { Typography } from 'components/generic/typography';
import useSegmentation from 'hooks/user/useSegmentation';

export type CookieInfoboxProps = {
    headline: string;
    body: string;
    callback?: () => void;
};

const StyledCard = styled(Card)`
    && {
        width: 264px;
    }
`;

const Grid = styled.div`
    display: grid;
    gap: 16px;
`;

const StyledButton = styled(Button)`
    width: 100%;
`;

function CookieInfobox(props: CookieInfoboxProps & HTMLAttributes<HTMLDivElement>) {
    const { headline, body, callback, ...restProps } = props;
    const { t } = useTranslation();
    const { culture } = useSegmentation();

    const languageCode = culture.split('-')[0].toUpperCase();

    const onClick = async () => {
        await ensureCookieConsentReady(languageCode);

        if ((window as any).CookieConsent) {
            (window as any).CookieConsent.show();
        }

        callback?.();
    };

    return (
        <StyledCard {...restProps}>
            <Card.Content>
                <Grid>
                    <Typography.Headline size="S">{headline}</Typography.Headline>
                    <Typography.Body as="span" size="S">
                        {body}
                    </Typography.Body>

                    <StyledButton size="sm" onClick={onClick}>
                        {t(OK)}
                    </StyledButton>
                </Grid>
            </Card.Content>
        </StyledCard>
    );
}

export default CookieInfobox;
